const Footer = () => {
    return ( 
        <div className = "footer">
            <p>Copyright @ caitlinraymond.com 2025</p>
        </div>
     );
}
 
export default Footer;